import React, { useState } from "react";
import axios from "axios";
import { Box, TextField, Button, Typography, Grid } from "@mui/material";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setResponseMessage(""); 

    try {
      const response = await axios.post(`${BASE_URL}/user/contact`, formData);
      if (response.data.success) {
        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          style: { backgroundColor: 'orange', color: 'white' }, 
        });
        setFormData({ name: "", email: "", message: "" }); 
      } else {
        setResponseMessage("Failed to send your message. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting the form:", error?.response);
      toast.error("Error submitting the form", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          justifyContent: "center", 
          alignItems: "center", 
        }}
      >
        <Box
          sx={{
            padding: "20px",
            maxWidth: "600px",
            margin: "50px auto",
            marginTop: "50px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            borderRadius: "8px",
            backgroundColor: "#fff",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            textAlign="center"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#333" }}
          >
            Contact Us
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Your Name"
                  variant="outlined"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Your Email"
                  variant="outlined"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Your Message"
                  variant="outlined"
                  multiline
                  rows={4}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: "#FF7900",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#e65500" },
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </form>
          {responseMessage && (
            <Typography
              variant="body1"
              sx={{ marginTop: "20px", textAlign: "center", color: "#333" }}
            >
              {responseMessage}
            </Typography>
          )}
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default ContactUs;